import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { trackPromise } from 'react-promise-tracker';
import { fetchWrapper } from '_utils/fetch-wrapper';
import { blobBrowserDownload } from '_utils/files/blobBrowserDownload';

// Create slice

const name = 'fileHubList';
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// Exports

export const fileHubListActions = { ...slice.actions, ...extraActions }; // Export actions
export const fileHubListReducer = slice.reducer; // Export reducer

function createInitialState() {
    return {
        fileHubList: null,
        loading: false,
        error: null
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api/UET`;

    return {
        getFileHubList: getFileHubList(),
        getUETResponseList: getUETResponseList(),
        getUETResponseCount: getUETResponseCount(),
        downloadUETResponse: downloadUETResponse(),
        deleteUETResponse: deleteUETResponse(),
    };

    // Action to fetch file hub list
    function downloadUETResponse() {
        return createAsyncThunk(
            `${name}/downloadUETResponse`,
            async (data, { rejectWithValue }) => {
                try {
                    const { blob, headers } = await fetchWrapper.postFile(
                      `${baseUrl}/marketer/uet/download-file`,
                      data,
                    );
                    const fallbackFileName =
                      data.bulkDownloadFiles.length === 1
                        ? data.bulkDownloadFiles[0]?.FileName
                        : null;

                    blobBrowserDownload(blob, headers, fallbackFileName, false);
                    return true;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

    function getFileHubList() {
        return createAsyncThunk(
            `${name}/getFileHubList`,
            async (data, { rejectWithValue }) => {
                try {
                    const url = `${baseUrl}/GetFileHub`;
                    const response = await trackPromise(fetchWrapper.post(url,data));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

    function getUETResponseList() {
        return createAsyncThunk(
            `${name}/getUETResponseList`,
            async (data, { rejectWithValue }) => {
                try {
                    const url = `${baseUrl}/UETResponse`;
                    const response = await trackPromise(fetchWrapper.post(url,data));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
     function getUETResponseCount() {
        return createAsyncThunk(
            `${name}/getUETResponseCount`,
            async (data, { rejectWithValue }) => {
                try {
                    const url = `${baseUrl}/PageCount`;
                    const response = await trackPromise(fetchWrapper.post(url,data));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
     function deleteUETResponse() {
        return createAsyncThunk(
            `${name}/deleteUETResponse`,
            async (data, { rejectWithValue }) => {
                try {
                    const url = `${baseUrl}/DeleteUetResponse`;
                    const response = await trackPromise(fetchWrapper.post(url,data));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }
    
}

function createReducers() {
    return {
        clear
    };

    function clear(state) {
        state.fileHubList = null;
        state.error = null;
    }
}

function createExtraReducers() {
    return (builder) => {
        // Get File Hub List action handling
        const { pending, fulfilled, rejected } = extraActions.getFileHubList;
        builder
            .addCase(pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fulfilled, (state, action) => {
                state.fileHubList = action.payload.Data;
                state.loading = false;
            })
            .addCase(rejected, (state, action) => {
                state.error = action.error.message;
                state.loading = false;
            });
    };
}
